import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import { useParams } from 'react-router-dom';

const InvoiceItemInput = ({ item, index, invoiceId }) => {
  const { invoiceItemId = '' } = useParams();
  const decodedId = invoiceItemId ? atob(invoiceItemId) : invoiceItemId;
  const id = decodedId.replace(/\D/g, ''); 
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'invoice_item';

  useEffect(() => {
    if (invoiceItemId) {
 
      setIsEditing(true);
      fetchInvoiceItemDetails();
    }


   
  }, [invoiceItemId]);



  const fetchInvoiceItemDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.invoice_item}${id}/`, { headers });
      const invoiceItemDetails = response.data;

      // setFormData(invoiceItemDetails);
    } catch (error) {
      console.error('Error fetching invoice item details:', error);
    }
  };

  const invoiceItemFields = [

    {
      name: 'invoice',
      type: 'hidden',
      value: invoiceId,
    },
    {
      name: 'description',
      label: 'Description',
      type: 'textarea',
    },
    {
      name: 'quantity',
      label: 'Quantity',
      type: 'number',
    },
    {
      name: 'unit_price',
      label: 'Unit Price',
      type: 'number',
    },
   
  ];



  return (
    <div>
      <h1>{isEditing ? 'Edit Invoice Item' : 'Create Invoice Item'}</h1>
 
      <FormComponent
        fields={invoiceItemFields}
        initialFormData={formData}
        route={route}
        
      />
    </div>
  );
};

export default InvoiceItemInput;